module.exports = __webpack_public_path__ + "static/media/push_image.bb861279.svg";